
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
// import Select from 'react-select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TextField } from "@mui/material";
import * as moment from 'moment';
import * as service from '../../../services/service';

function AddEditInvoice() {
    const [state, setState] = useState({
        invoiceno: '', basicamount: '', taxamount: '', invoicefilename: '', invoicefilepath: '',
        completionfilename: '', completionfilepath: '',
    });
    const [data, setData] = useState([]);
    const [invoiceDate, setInvoiceDate] = useState(new Date());
    const [completionFile, setCompletionFile] = useState('');
    const [invoiceFile, setInvoiceFile] = useState('');
    const [invoiceId, setInvoiceId] = useState('');
    const [totalInvoiceAmount, setTotalInvoiceAmount] = useState('');
    const [errors, setError] = useState({});
    const [loading, setLoading] = useState(false);
    // const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const eventName = JSON.parse(localStorage.getItem('eventname'))
    const categoryName = JSON.parse(localStorage.getItem('categoryname'))
    const agencyName = JSON.parse(localStorage.getItem('agencyname'))
    const quotationAmount = JSON.parse(localStorage.getItem('tenderamount'))
    const eventExecution = JSON.parse(localStorage.getItem('eventexecution'))
    // const workOrderNo = JSON.parse(localStorage.getItem('workorderno'))
    const workOrderAmount = JSON.parse(localStorage.getItem('workorderamount'))
    const quotationId = JSON.parse(localStorage.getItem('quotationid'))
    const navigate = useNavigate();
    const { workOrderId, eventId } = useParams();

    const getInvoiceDetails = () => {
        fetch(
            service.GET_INVOICE_BY_WORK_ORDER_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: JSON.stringify({
                    WorkOrderId: workOrderId,
                })
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
                if (result.length === 0) {
                    setError('No Data Found');
                }
            })
            .catch(err => {
                if (err) {
                    setError(err);
                };
            });
    };

    const getDetailsById = (id) => {
        setLoading(true);
        const errs = {};
        if (id > 0) {
            fetch(
                service.GET_INVOICE_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({
                        InvoiceId: id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        setState({
                            ...state, invoiceno: result.invoiceNumber, basicamount: result.basicAmount,
                            taxamount: result.taxAmount, 
                            completionfilename: result.completionFileName, completionfilepath: result.completionFilePath,
                            invoicefilename: result.invoiceFileName, invoicefilepath: result.invoiceFilePath,
                        });
                        setInvoiceDate(new Date(result.invoiceDate));
                        setTotalInvoiceAmount(result.totalInvoiceAmount);
                        setInvoiceId(id);
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setError(errs);
                    }
                });
        }
        setLoading(false);
    };

    useEffect(() => {
        if (workOrderId > 0) {
            getInvoiceDetails();
        }
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!state.invoiceno) {
            isValid = false;
            errs[".invoiceno"] = "Please enter invoice no";
        }
        if (!state.basicamount) {
            isValid = false;
            errs[".basicamount"] = "Please enter basic amount";
        }
        if (!state.taxamount) {
            isValid = false;
            errs[".taxamount"] = "Please enter tax amount";
        }
        if (!totalInvoiceAmount) {
            isValid = false;
            errs[".totalinvoiceamount"] = "Please enter total invoice amount";
        }
        if (!invoiceDate) {
            isValid = false;
            errs[".invoiceDate"] = "Please enter invoice date";
        }
        setError(errs);
        return isValid;
    }
   
    const changeHandler = (event) => {
        if (event.target.name === 'basicamount' || event.target.name === 'taxamount' || event.target.name === 'totalinvoiceamount') {
            if (Number.isNaN(parseFloat(event.target.value))) {
                // eslint-disable-next-line
                alert("Please enter numbers only");
                event.target.value = ""; // eslint-disable-line no-param-reassign
            }
        }
        if(event.target.name === 'taxamount'){            
            const total = parseFloat(state.basicamount) + parseFloat(event.target.value);        
            setTotalInvoiceAmount(total);
        }
        if(event.target.name === 'basicamount'){            
            const total = parseFloat(state.taxamount) + parseFloat(event.target.value);        
            setTotalInvoiceAmount(total);
        }

        setState({ ...state, [event.target.name]: event.target.value });        
    };

    const handleDownload = (fileName, filePath) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("FileName", fileName);
        formData.append("FilePath", filePath);
        fetch(
            service.DOWNLOAD_FILE,
            {
                method: 'POST',
                headers: {
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: formData
            })
            .then((response) => response.blob())
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    fileName,
                );
                // Append to html link element page
                document.body.appendChild(link);
                // Start download
                link.click();
                // Clean up and remove the link
                link.parentNode.removeChild(link);
            });

        setLoading(false);
    };

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            const formData = new FormData();
            formData.append("InvoiceId", invoiceId > 0 ? invoiceId : 0);
            formData.append("WorkOrderId", workOrderId);
            formData.append("EventId", eventId);
            formData.append("InvoiceDate", (new Date(invoiceDate)).toUTCString());
            formData.append("InvoiceNumber", state.invoiceno);
            formData.append("BasicAmount", state.basicamount);
            formData.append("TaxAmount", state.taxamount);
            formData.append("TotalInvoiceAmount", totalInvoiceAmount);
            formData.append("CompletionFile", completionFile);
            formData.append("InvoiceFile", invoiceFile);
            formData.append("AddedBy", JSON.parse(window.sessionStorage.getItem('userData')).userId);
            formData.append("UpdatedBy", JSON.parse(window.sessionStorage.getItem('userData')).userId);
            fetch(
                service.ADD_UPDATE_INVOICE,
                {
                    method: 'POST',
                    headers: {
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: formData
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        window.location.reload();
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setError(errs);
                    }
                });
        }
        setLoading(false);
    }

    const backHandler = () => {
        localStorage.setItem('workorderno', null);
        localStorage.setItem('workorderamount', null);
        localStorage.setItem('quotationid', null);
        navigate(`/addeditworkorder/${quotationId}/${eventId}`);
    }

    const handleEdit = (id) => {
        getDetailsById(id);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Invoice Details
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                {/* <TableContainer component={Paper} style={{ width: '90%', alignSelf: 'center', }}> */}
                                <Table>
                                    <TableRow>
                                        <TableCell width="45%" style={{ fontWeight: 'bold' }}>
                                            Event Category : {categoryName}
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>
                                            Event Name : {eventName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ fontWeight: 'bold' }}>
                                            Event Execution : {eventExecution}
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>
                                            Agency Name : {agencyName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ fontWeight: 'bold' }}>
                                            Tender Amount : {quotationAmount}
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>
                                            Work Order Amount : {workOrderAmount}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Invoice No." fullWidth value={state.invoiceno || ''}
                                                name="invoiceno"
                                                onChange={changeHandler}
                                                id="invoiceno"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invoiceno"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div> Invoice Date </div>
                                            <DatePicker
                                                id="invoiceDate"
                                                selected={invoiceDate}
                                                onChange={date => setInvoiceDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                                tabIndex={0}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invoiceDate"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Basic Amount" fullWidth value={state.basicamount || ''}
                                                name="basicamount"
                                                onChange={changeHandler}
                                                id="basicamount"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".basicamount"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <MDInput label="Tax Amount" fullWidth value={state.taxamount || ''}
                                                name="taxamount"
                                                onChange={changeHandler}
                                                id="taxamount"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".taxamount"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Total Invoice Amount" fullWidth value={totalInvoiceAmount}
                                                name="totalinvoiceamount"
                                                onChange={changeHandler}
                                                id="totalinvoiceamount"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".totalinvoiceamount"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <div>Upload Completion File (File Size 5 MB)</div>
                                            <TextField
                                                id="completionFile"
                                                type="file"
                                                onChange={ev => setCompletionFile(ev.target.files[0])}
                                                style={{ width: 200 }}
                                                required
                                            />
                                            {state.completionfilename ?
                                                <MDButton onClick={() => handleDownload(state.completionfilename, state.completionfilepath)}>{state.completionfilename}</MDButton>
                                                : null}
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".completionFile"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div>Upload Invoice File (File Size 5 MB)</div>
                                            <TextField
                                                id="invoiceFile"
                                                type="file"
                                                onChange={ev => setInvoiceFile(ev.target.files[0])}
                                                style={{ width: 200 }}
                                                required
                                            />
                                            {state.invoicefilename ?
                                                <MDButton onClick={() => handleDownload(state.invoicefilename, state.invoicefilepath)}>{state.invoicefilename}</MDButton>
                                                : null}
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invoiceFile"]}</div>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                                {/* </TableContainer> */}
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>  &nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={backHandler}>
                                                BACK
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>
                            </Card>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold' }}>Invoice No.</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Basic Amount</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Tax Amount</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Total Invoice Amount</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Invoice Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Completion File</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Invoice File</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                                                <TableCell align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.invoiceId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell width="10%" component="th" scope="row">{row.invoiceNumber}</TableCell>
                                                        <TableCell width="15%" component="th" scope="row">{row.basicAmount}</TableCell>
                                                        <TableCell width="15%" component="th" scope="row">{row.taxAmount}</TableCell>
                                                        <TableCell width="15%" component="th" scope="row">{row.totalInvoiceAmount}</TableCell>
                                                        <TableCell width="15%" component="th" scope="row">{moment(row.invoiceDate).format('DD/MM/YYYY')}</TableCell>
                                                        <TableCell width="20%" component="th" scope="row"><MDButton onClick={() => handleDownload(row.completionFileName, row.completionFilePath)}>{row.completionFileName}</MDButton></TableCell>
                                                        <TableCell width="20%" component="th" scope="row"><MDButton onClick={() => handleDownload(row.invoiceFileName, row.invoiceFilePath)}>{row.invoiceFileName}</MDButton></TableCell>
                                                        <TableCell width="15%" component="th" scope="row">{row.status}</TableCell>
                                                        <TableCell><MDButton onClick={() => handleEdit(row.invoiceId)}>Edit</MDButton></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default AddEditInvoice;